import React from "react";
import { useMeasure } from "react-use";

import { StatGrid, type StatGridProps } from "./_stat-grid";

interface StatChartWidgetProps extends Omit<StatGridProps, "height" | "width"> {
	onShowAll: VoidFunction;
}

export const StatChartWidget = React.memo<StatChartWidgetProps>((props) => {
	const [measureRef, { width, height }] = useMeasure<HTMLDivElement>();

	return <StatGrid height={height} ref={measureRef} width={width} {...props} />;
});
